import React from 'react';

const UserModal = ({ children }) => {
    return (
        <div className="user-modal">
            {children}
        </div>
    )
}

export default UserModal;
